var XPortal = XPortal || {};
XPortal.Modal = (function () {
    var self = {};

    self.modalSelector = '#modalBox';

    self.init = function (modalSelector) {
        self.setEvents(modalSelector ? modalSelector : self.modalSelector);
    };

    self.prepareModalFromTemplate = function (templateSelector, disableCloseOnOverlayClick, onDismissCallback, xmodalSelector, xoptions) {
        var $template = templateSelector instanceof jQuery ? templateSelector : $(templateSelector);
        var content = $template.prop('content');
        var $content = content ? $($template.prop('content')) : $template;
        var $html = $content.find('[data-modal-title]');

        var modalParams = [{
            dataset: $.extend({
                showModal: true,
                disableCloseOnOverlayClick: disableCloseOnOverlayClick,
                modalSelector: xmodalSelector ? xmodalSelector : $html.attr('data-modal-selector'),
                modalTitle: $html.attr('data-modal-title'),
                modalText: $template.html(),
                modalType: $html.attr('data-modal-type'),
                modalBackDrop: $html.attr("data-modal-backdrop"),
                modalKeyboard: $html.attr("data-modal-keyboard"),
                modalWidth: $html.attr('data-modal-width'),
                modalHeight: $html.attr('data-modal-height'),
                modalMaxHeight: $html.attr('data-modal-maxheight'),
                modalMinimize: $html.attr('data-modal-minimize'),
                onDismiss: onDismissCallback
            }, xoptions || {})
        }];

        self.checkIfModal(modalParams);
    };

    self.checkIfModal = function (data) {
        var el = $(data)[0];
        if (el && el.dataset && el.dataset.showModal) {
            var $this = cleanUpContainer($(el.dataset.modalSelector ? el.dataset.modalSelector : self.modalSelector));
            var $modalDialog = $this.find('.modal-dialog');
            var $modalBody = $this.find('.modal-body');
            if (el.dataset.modalType) {
                $this.attr('modal-type', el.dataset.modalType);
            } else {
                $this.removeAttr('modal-type');
            }

            if (el.dataset.modalBackDrop) {
                $this.attr('modal-backdrop', el.dataset.modalBackDrop);
            } else {
                $this.removeAttr('modal-backdrop');
            }

            if (el.dataset.modalWidth && el.dataset.modalWidth !== '0') {
                $modalDialog.css('max-width', el.dataset.modalWidth + 'px');
            } else {
                $modalDialog.css('max-width', '');
            }

            if (el.dataset.modalHeight && el.dataset.modalHeight !== '0') {
                $modalBody.css({ 'height': el.dataset.modalHeight + 'px', 'overflow': 'auto' });
            } else {
                $modalBody.css({ 'height': '' });
            }

            if (el.dataset.modalMaxHeight && el.dataset.modalMaxHeight !== '0') {
                $modalBody.css({ 'max-height': el.dataset.modalMaxHeight + 'px', 'overflow': 'auto' });
            } else {
                $modalBody.css({ 'max-height': '' });
            }

            if ((!el.dataset.modalHeight || el.dataset.modalHeight === '0')
                && (!el.dataset.modalMaxHeight || el.dataset.modalMaxHeight === '0')) {
                $modalBody.css({ 'overflow': '' });
            }

            if (el.dataset.modalTitle) {
                $this.find('.modal-header-cnt').html('<h4 class="modal-title">' + $.trim(el.dataset.modalTitle) + '</h4>');
            }
            if (el.dataset.modalMinimize) {
                $this.find('.minimize').removeClass('d-none');
            }

            $this.find('.modal-body').html(el.dataset.modalText ? el.dataset.modalText : el.children);
            var modalOptions = { keyboard: el.dataset.modalKeyboard === 'true' };
            if (el.dataset.disableCloseOnOverlayClick) {
                modalOptions.backdrop = "static";
            }

            if (el.dataset.onDismiss) {
                $this.one("hidden.bs.modal", el.dataset.onDismiss);
            }
            if (el.dataset.beforeRender) el.dataset.beforeRender($this, el.dataset, modalOptions);
            if (modalOptions.show) {
                $this.off("shown.bs.modal");
                $this.on("shown.bs.modal", function () {
                    if (el.dataset.afterRender) el.dataset.afterRender($this, el.dataset);
                });
            }
            $this.addClass('modal-opened');
            $this.modal(modalOptions);
            if (!modalOptions.show)
                if (el.dataset.afterRender) el.dataset.afterRender($this, el.dataset);
            return true;
        }

        return false;
    };

    self.closeModal = function (data, xmodalSelector) {
        if (data != null) {
            var form = data.closest('form');
            if (form) form.off();
        }

        $(xmodalSelector ? xmodalSelector : self.modalSelector).modal('hide');
    };
    self.hideModal = function (xmodalSelector, onDone) {
        return self.showHideModal(xmodalSelector, onDone, 'hide');
    };
    self.showModal = function (xmodalSelector, onDone) {
        return self.showHideModal(xmodalSelector, onDone, 'show');
    };
    self.showHideModal = function (xmodalSelector, onDone, actionName) {
        var isShowAction = actionName == 'show';
        var eventName = isShowAction ? 'shown.bs.modal' : 'hidden.bs.modal';
        $this = $(xmodalSelector ? xmodalSelector : self.modalSelector);
        $this.off(eventName);
        $this.on(eventName, function () {
            if (onDone) onDone();
        });
        var curState = ($this.data("bs.modal") || {});
        if (curState._isShown == isShowAction || curState._isTransitioning) if (onDone) onDone();
        $this.modal(actionName);
    };

    self.confirm = function (params, onConfirmation, onDismiss) {
        var confirmationParams = params == null ? { options: { headerText: document.title, confirmationText: 'Are you sure?' } } : params;
        var $this = $(self.modalSelector),
            $confirmBlock = $this.find('.confirmation-block');

        $confirmBlock.removeClass('d-none');
        $this.find('.modal-header-cnt').html('<h4 class="modal-title">' + $.trim(confirmationParams.options.headerText) + '</h4>');
        $this.find('.modal-body').html(confirmationParams.options.IsForm ? confirmationParams.options.confirmationText : '<p>' + confirmationParams.options.confirmationText + '</p>');

        if (confirmationParams.options.hasOwnProperty('buttonsText')) {
            if (confirmationParams.options.buttonsText.length > 0) {
                $confirmBlock.find('button').each(function () {
                    $(this).text(confirmationParams.options.buttonsText.splice(0, 1));
                });
            }
        } else {
            $confirmBlock.addClass('d-none');
        }

        $confirmBlock.one('click', 'button[data-action="submit"]', function () {
            confirmationParams.result = 'yes';

            $confirmBlock.addClass('d-none');
            self.closeModal(null, $this);
        }).one('click', 'button[data-action="cancel"]', function () {
            confirmationParams.result = 'no';
            $confirmBlock.addClass('d-none');
            self.closeModal(null, $this);
        });
        $this.off('hidden.bs.modal');
        $this.on('hidden.bs.modal', function (event) {
            self.resetPopupOnClose(event);
            if (onConfirmation) onConfirmation(confirmationParams);
        });

        if (onDismiss) {
            $this.one('click', 'button[data-dismiss="modal"]', function () {
                confirmationParams.result = 'no';
                onDismiss(confirmationParams);
            });
        }

        if (confirmationParams.options.OnInit) {
            confirmationParams.options.OnInit($this);
        }

        if (confirmationParams.options.modalType) {
            $this.attr('modal-type', confirmationParams.options.modalType);
        }

        var modalOptions = { keyboard: false };
        if (confirmationParams.options.disableCloseOnOverlayClick) {
            modalOptions.backdrop = "static";
        }
        $this.modal(modalOptions);
    };

    self.alert = function (params, onConfirmation) {
        var alertParams = params == null ? { headerText: '-', message: '-' } : params;
        self.closeModal();
        setTimeout(function () {
            var $this = $(self.modalSelector);
            if (alertParams.modalType) {
                $this.attr('modal-type', alertParams.modalType);
            }

            $this.find('.alert-block').removeClass('d-none');
            $this.find('.modal-header-cnt').html('<h4 class="modal-title">' + $.trim(alertParams.headerText) + '</h4>');
            $this.find('.modal-body').html('<div>' + alertParams.alertText + '</div>');
            $this.find('.alert-block').one('click', 'button[data-action="cancel"]', function () { $this.find('.alert-block').addClass('d-none'); self.closeModal(); });
            $this.modal({ keyboard: false });
            $this.off('hidden.bs.modal');
            $this.on('hidden.bs.modal', function (event) {
                self.resetPopupOnClose(event);
                if (onConfirmation) onConfirmation();
            });
        }, 500);
    };

    self.resetPopupOnClose = function (event) {
        var $this = $(event.target);
        $this.off('hidden.bs.modal');
        $this.removeClass('modal-opened');
        $this.removeAttr('modal-type');
        $this.find('.confirmation-block').off().addClass("d-none");
        $this.find('.alert-block').off().addClass("d-none");
        $this.find('.modal-body').empty();
        $this.find('.modal-header-cnt').empty();
        self.adjustHeaderOnOpenModal(0);
    };

    self.setEvents = function (selector) {
        $(selector).on('hidden.bs.modal', function (event) {
            self.resetPopupOnClose(event);
        }).on('shown.bs.modal', function () {
            var $this = $(this);
            ajaxResponseValidation($this);

            $this.find('form').on('click', 'button[type="button"]', function () {
                self.closeModal($(this).closest('form'));
            });

            XPortal.Main.RecalculateContentElementsSizes($(selector), 200);
            if (XPortal.FEditor) {
                XPortal.FEditor.InitContentElements(selector);
            }

            XPortal.Main.customThemes(self.modalSelector);
            self.adjustHeaderOnOpenModal();
            XPortal.inputHandler.Init($this);
        });
    };

    self.adjustHeaderOnOpenModal = function(ofset){
        var scrollbarWidth = 0;
        if (ofset) {
            scrollbarWidth = ofset;
        } else {
            scrollbarWidth = document.body.style.paddingRight;
        }
        $('.header-wrapper.fixed').css('padding-right', `${scrollbarWidth}`);
    }

    function cleanUpContainer(icontainer) {
        var container = icontainer ? $(container) : container;
        if (!(container && container.length)) return icontainer;
        var cid = (container).attr("id");
        var copyId = cid + "_ihtml";
        if ($("#" + copyId).length == 0) {
            $("<div class='d-none invisible'/>")
                .attr("id", copyId)
                .html(container.html())
                .appendTo(container.parent());
        } else {
            container.empty().html("").html($("#" + copyId).html());
        }
        return container;
    }
    return self;
}());